const postProcessorConfig = {
  title: "Configure Processor",
  configured_processors_for: "Configured processors for",
  table: "Table",
  no_processors_configured:
    'No processors configured yet for this field. Click "+ Create new processor" below.',
  create_new_processor: "Create new processor",
  processor_type: "Processor type",
  lookup_conditions: "Lookup conditions",
  lookup_conditions_description:
    "Entries sharing the same groupId are AND'd together. Different groupIds are fallback options tried in order — first matching group wins. For TableLevel, lookupField is resolved against the current row first, then falls back to the header.",
  properties_to_copy: "Properties to copy",
  properties_to_copy_description:
    "For each entry, the value of predefineFieldProperty on the matched ExpectedValue is written to destinationField on the document (header or row, depending on scope).",
  processor_name: "Processor name",
  lookup_predefined_values_copy_properties:
    "lookup predefined values, copy properties",
  processor_name_required: "Processor name is required",
  group_id: "Group ID",
  lookup_field: "Lookup field",
  predefined_value: "Predefined value",
  predefined_field_property: "Predefined field property",
  lookup_predefined_field_property: "Lookup Predefined field property",
  semantic: "Semantic",
  destination_field: "Destination field",
  group_id_required: "Group ID is required",
  lookup_field_required: "Lookup field is required",
  lookup_property_required: "Lookup property is required",
  predefined_value_required: "Predefined value is required",
  predefined_field_property_required: "Predefined field property is required",
  destination_required: "Destination field is required",
  order_must_be_number: "Order must be a number",
  order_required: "Order is required",
  at_least_one_lookup: "At least one lookup configuration is required",
  add_lookup_condition: "Add lookup condition",
  add_copy_entry: "Add copy entry",
  auto_selection: "AutoSelection",
  processor_updated_successfully: "Processor updated successfully",
  processor_created_successfully: "Processor created successfully",
  delete_processor: "Delete Processor",
  delete_confirmation: "Are you sure want to delete {{processorName}}?",
  confirm: "Confirm",
  cancel: "Cancel",
  processor_deleted_successfully: "Processor deleted successfully",
  mode: "Mode",
  lookup: "Lookup",
  constant: "Constant",
  lookup_predefined_field_property_placeholder: "Constant Value",
  constant_value_required: "Constant value is required",
  consistent_field: "Consistent Field",
  consistent_field_description: "consistent field values, copy values",
  basic_information: "Basic Information",
  header_seeding: "Header Seeding",
  consider_header_field: "Consider the header field",
  consider_header_field_description:
    "When on, the header field seeds the top of the cascade (its value fills the first empty row, then values flow down to later empty rows). When off, empty cells only inherit from the row above.",
  bottom_seeding: "Bottom Seeding",
  consider_bottom_field: "Consider the bottom field",
  consider_bottom_field_description:
    "When on, the bottom field seeds the bottom of the cascade (its value fills the first empty row, then values flow up to earlier empty rows). When off, empty cells only inherit from the row below.",
  order: "Order",
  save: "Save",
  next: "Next",
  type: "Type",
  rule_type: "Rule Type",
  pattern: "Pattern (.NET Regex)",
  replace_with: "Replace With",
  replace_with_description:
    "Used only when rule type is Replace. Empty removes the match.",
  replace_only: "Replace Only",
  conditions: "Conditions",
  conditions_description:
    "All conditions must hold (AND), compared case-insensitively. The rule runs only when every condition matches. A condition on the same table as the target is checked per row; a header condition gates the whole write.",
  field_name: "Field",
  condition_value: "Value (case-insensitive)",
  add_condition: "Add condition",
  rule_type_replace: "Replace",
  rule_type_match: "Match",
  rule_type_required: "Rule type is required",
  pattern_required: "Pattern is required",
  regex: "Regex",
  regex_description: "apply regex rules to field values",
  prevent_reuse_of_already_selected_within_document:
    "Prevent reuse of already selected within document",
  prevent_reuse_of_already_selected_within_document_description:
    "When enabled, options that have already been selected elsewhere in the document will not be reused.",
  generate_regex: "Generate Regex",
  generate_regex_subtitle:
    "Describe the transformation and give an example — AI will generate the pattern for you.",
  instructions: "Instructions",
  instructions_placeholder: "e.g. Remove leading zeros from the value",
  instructions_required: "Instructions are required",
  before: "Before",
  before_placeholder: "e.g. 000123",
  before_required: "Before value is required",
  after: "After",
  after_placeholder: "e.g. 123",
  after_required: "After value is required",
  replace_value: "Replace Value",
  generate: "Generate",
  regex_generated_successfully: "Regex generated successfully",
  regex_generation_failed:
    "Could not generate a regex. Please refine your inputs.",
  regex_validation_not_passed:
    "Regex generated, but it does not produce the expected output for every example. Please review it.",
  instructions_hint:
    'Natural language directions telling the AI what to extract. Example: "Extract only the digits after the dollar sign."',
  before_hint:
    'The raw value text from the document (e.g. "Total Amount: $54.00").',
  after_hint: 'What exactly should be extracted (e.g. "54.00").',
  replace_value_hint:
    "Hardcodes a specific value when the rule triggers (e.g. assigning 'Unknown' to a field).",
};

export default postProcessorConfig;
